/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_OfflineInputs */

const en_editor_offline = /** @type {(inputs: Editor_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're offline. Recipes can be edited once you're back online.`)
};

const de_editor_offline = /** @type {(inputs: Editor_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist offline. Rezepte lassen sich bearbeiten, sobald du wieder online bist.`)
};

/**
* | output |
* | --- |
* | "You're offline. Recipes can be edited once you're back online." |
*
* @param {Editor_OfflineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_offline = /** @type {((inputs?: Editor_OfflineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_OfflineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_offline(inputs)
	return en_editor_offline(inputs)
});